module.exports = __webpack_public_path__ + "static/img/shezhi_vip.61c96c56.png";